import styled from "@emotion/styled";

export const PreTextContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.main[9]};
  border-top: 0;
  border-bottom: 0;
  padding: 10px;
`;
